import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const COLOR_FOUNDATION_TOKENS = [
  // Highlight (brand & action)
  'highlight-darkest',
  'highlight-dark',
  'highlight-default',
  'highlight-medium',
  'highlight-light',
  // Primary Alpha (interaction overlays)
  'primary-alpha-5',
  'primary-alpha-10',
  'primary-alpha-50',
  'primary-alpha-60',
  // White scale (on dark surfaces)
  'white-100',
  'white-80',
  'white-60',
  'white-40',
  'white-20',
  'white-10',
  'white-5',
  // Tertiary scale (AI/purple) — subset needed for tailwind-merge conflict resolution
  'tertiary-5',
  'tertiary-10',
  // Extras family (telephony + accent colors)
  'extra-answer',
  'extra-decline',
  'extra-voip',
  'extra-voip-light',
  'extra-message',
  'extra-yellow',
  'extra-orange',
  'extra-pink',
  'extra-pink-light',
  'extra-blue',
];

const GRADIENT_TOKENS = [
  'gradient-primary',
  'gradient-highlight',
  'gradient-secondary',
  'gradient-tertiary',
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'text-color': COLOR_FOUNDATION_TOKENS.map((t) => `text-${t}`),
      'bg-color': COLOR_FOUNDATION_TOKENS.map((t) => `bg-${t}`),
      'bg-image': GRADIENT_TOKENS.map((t) => `bg-${t}`),
      'border-color': COLOR_FOUNDATION_TOKENS.map((t) => `border-${t}`),
      'ring-color': COLOR_FOUNDATION_TOKENS.map((t) => `ring-${t}`),
      fill: COLOR_FOUNDATION_TOKENS.map((t) => `fill-${t}`),
      stroke: COLOR_FOUNDATION_TOKENS.map((t) => `stroke-${t}`),
      'font-size': [
        'text-2xl',
        'text-xl',
        'text-l',
        'text-ml',
        'text-m',
        'text-sm',
        'text-s',
        'text-xs',
        'text-2xs',
        'text-tiny',
        // Design system typography classes
        'text-heading-32',
        'text-heading-24',
        'text-heading-20',
        'text-heading-18',
        'text-heading-16',
        'text-heading-14',
        'text-heading-13',
        'text-heading-12',
        'text-body-20',
        'text-body-20-bold',
        'text-body-18',
        'text-body-18-bold',
        'text-body-16',
        'text-body-16-bold',
        'text-body-14',
        'text-body-14-bold',
        'text-body-13',
        'text-body-13-bold',
        'text-body-12',
        'text-body-12-bold',
      ],
      // text-mono sets font-family/weight/line-height but NOT font-size,
      // so it must not conflict with text-body-* size classes.
      'font-family': ['text-mono'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
